import React from 'react';
import Logo from '../components/Logo';

const Privacy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <Logo size="lg" />
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-4 py-10">
        <h1 className="text-2xl font-bold mb-4">Política de Privacidad</h1>
        <p className="text-gray-700">Este es un texto informativo de ejemplo. Aquí puedes incluir tu política de privacidad.</p>
      </div>
    </div>
  );
};

export default Privacy;

